import getIsSafari from "selectors/device/getIsSafari";
import getIsMobileSafari from "selectors/device/getIsMobileSafari";
import getIsSamsung from "selectors/device/getIsSamsung";
import getIsUIWebView from "selectors/device/getIsUIWebView";
import getOsVersionFloat from "selectors/device/getOsVersionFloat";
import getBrowserVersionFloat from "selectors/device/getBrowserVersionFloat";
import { createSelector } from "reselect";

export default createSelector(
  getBrowserVersionFloat,
  getIsMobileSafari,
  getIsSafari,
  getIsSamsung,
  getIsUIWebView,
  getOsVersionFloat,
  (
    browserVersionFloat,
    isMobileSafari,
    isSafari,
    isSamsung,
    isUIWebView,
    osVersionFloat,
  ) => {
    if (
      (isMobileSafari && osVersionFloat && osVersionFloat >= 11) ||
      (!isMobileSafari &&
        isSafari &&
        !isSamsung &&
        browserVersionFloat &&
        browserVersionFloat >= 11)
    ) {
      return !isUIWebView;
    }

    return false;
  },
);
